import Vue from 'vue'
import Vuex from 'vuex'

import subsomeone from './subsomeone';
import singleproduct from './singleproduct';
import transaction from './transaction'
Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    subsomeone,
    singleproduct,
    transaction
  }
})
